import { PLANTINGTYPEReducer } from "../reducer/PlantingTypeReducer";

export const reducer = PLANTINGTYPEReducer;
